module.exports = __webpack_public_path__ + "img/condicionesDivisiones.af969f5b.svg";